import { gql } from '@apollo/client';

export const GET_TMS_WAYPOINT_LOADING_INFO_LIST = gql`
    query TmsWaypointLoadingInfoList($taskId: Long!, $taskWaypointId: Long!) {
        getTmsWaypointLoadingInfoList(taskId: $taskId, taskWaypointId: $taskWaypointId) {
            barCode
            parcelQuantity
            isBag
            destinationSortingCode
            isRemoved
        }
    }
`;

export interface TmsWaypointLoadingInfoType {
    barCode: string;
    parcelQuantity: number;
    isBag: boolean;
    destinationSortingCode?: string | null;
    isRemoved: boolean;
}

export interface GetTmsWaypointLoadingInfoListResponse {
    getTmsWaypointLoadingInfoList: TmsWaypointLoadingInfoType[];
}

export interface GetTmsWaypointLoadingInfoListVariables {
    taskId: number;
    taskWaypointId: number;
}
